module.exports = __webpack_public_path__ + "img/1ec230f.svg";